import { render } from "./CatProyectoForm.vue?vue&type=template&id=4698a27e&scoped=true"
import script from "./CatProyectoForm.vue?vue&type=script&lang=js"
export * from "./CatProyectoForm.vue?vue&type=script&lang=js"

import "./CatProyectoForm.vue?vue&type=style&index=0&id=4698a27e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4698a27e"]])

export default __exports__